import React, { useCallback, useState } from "react";
import { Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { useDealActions } from "store";
import { ProgressOverlay } from "components/Progress-overlay/ProgressOverlay";
import { useActionHook, useNavigate } from "hooks";

interface Props {
  id: number;
}

export const DeleteSharedDeal: React.FC<Props> = ({ id }) => {
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);

  const { deleteSharedDealAction } = useDealActions();
  const navigate = useNavigate();

  const { loading, action: deleteSharedDeal } = useActionHook(deleteSharedDealAction, {
    onSuccess: () => navigate({ route: "myDeals" })
  });

  const handleOpenPopup = useCallback(() => {
    setIsPopupOpen(true);
  }, []);

  const handleClosePopup = useCallback(() => {
    setIsPopupOpen(false);
  }, []);

  return (
    <>
      <Button onClick={handleOpenPopup} size="sm" variant="outlined">
        Delete deal
      </Button>
      <Modal open={isPopupOpen}>
        <ProgressOverlay
          containerSX={{
            ...style,
            display: "flex",
            flexDirection: "column",
            width: 520,
            p: "32px",
            borderRadius: "8px",
            bgcolor: "white",
            gap: "24px",
            boxShadow:
              "0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)"
          }}
          inProgress={loading}
        >
          <Stack direction="row" sx={{ justifyContent: "space-between", borderBottom: "1px solid #DBE8F5", pb: "6px" }}>
            <Typography sx={{ fontSize: "18px", lineHeight: "24px", color: "#071F35", fontWeight: 400 }}>
              Delete deal
            </Typography>
            <IconButton size="sm" onClick={handleClosePopup}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Typography sx={{ color: "#071F35", fontSize: "14px", lineHeight: "16px", fontWeight: 400 }}>
            Delete ONLY from the users account, this will not remove the deal from the original user who shared the
            account.
          </Typography>
          <Stack direction="row" sx={{ justifyContent: "flex-end", gap: "8px" }}>
            <Button onClick={handleClosePopup} variant="outlined">
              Cancel
            </Button>
            <Button onClick={() => deleteSharedDeal(id)} variant="contained">
              Ok
            </Button>
          </Stack>
        </ProgressOverlay>
      </Modal>
    </>
  );
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px"
};
